// 🧊 **3D 자산 창고 표**(1단계 · `scripts/blender/manifest.json` 의 미러). 색 mp4 + 마스크 mp4 두 벌이 기본 계약이고
//   알파 WebM 은 허용 대안이다(정본 지도 ADR 09-29). ★자산 파일은 레포에 싣지 않는다★ — R2 공개 버킷 + 이 장부.
// ★장부와 어긋나면 테스트가 잰다★(`tests/unit/promo-reel-assets.test.ts` 가 manifest.json 과 id·fps·frames 를 대조).
// ★삭제 규칙★ — id 를 지우거나 프레임 수·시드를 바꾸기 전 `src/` grep(manifest.json `removal`).
// 🧊 09-30 모션 브리핑 3D 층: 16:9(1920×1080 · 밝은 캔버스용) 7종을 같은 표에 얹었다(`aspect: "16:9"`). 세로 쇼릴·조립 EF 가 쓰는
//   `MOTION_3D_ASSET_IDS` 는 세로(9:16)만 — 16:9 는 `MOTION_3D_ASSET_IDS_169`. 16:9 부품은 무채색으로 구웠다(`tint: "neutral"`):
//   리모션이 색 층 위에 브랜드색을 캔버스 `color` 블렌드로 입힌다(명암은 남고 색상만 바뀜). 마스크는 여전히 matte 만.

export const MOTION_3D_BASE = "https://pub-6e875c782c654b92bb480138c507492a.r2.dev/motion-3d";

export type Motion3dAspect = "9:16" | "16:9";

export interface Motion3dAsset {
  id: string;
  fps: number;
  frames: number;
  durationSec: number;
  /** 화면 비율 — 세로(1080×1920 · 쇼릴) / 가로(1920×1080 · 모션 브리핑). */
  aspect: Motion3dAspect;
  /** 색 층에 색이 구워져 있나(`baked`) · 무채색이라 리모션이 색을 입히나(`neutral`). 마스크 전용은 `none`. */
  tint: "baked" | "neutral" | "none";
  /** 카메라 투영 bbox(프레임별 [x0,y0,x1,y1] px) 가 있는 자산 — 글자↔로고 겹침 검사가 읽는다. */
  bbox: boolean;
  /** 마스크만 쓰는 전환 자산(색 층은 그리지 않는다). */
  matteOnly: boolean;
  purpose: string;
}

const V: Motion3dAspect = "9:16";
const L: Motion3dAspect = "16:9";

export const MOTION_3D_ASSETS: readonly Motion3dAsset[] = [
  { id: "logo-sting", fps: 30, frames: 120, durationSec: 4, aspect: V, tint: "baked", bbox: true, matteOnly: false, purpose: "와카 로고 스팅 — 조각 3개 조립 → 회전 → 퇴장" },
  { id: "orbs-back", fps: 60, frames: 180, durationSec: 3, aspect: V, tint: "baked", bbox: false, matteOnly: false, purpose: "구슬 샌드위치 뒤층(글자 뒤)" },
  { id: "orbs-front", fps: 60, frames: 180, durationSec: 3, aspect: V, tint: "baked", bbox: false, matteOnly: false, purpose: "구슬 샌드위치 앞층(글자 앞)" },
  { id: "particles", fps: 30, frames: 150, durationSec: 5, aspect: V, tint: "baked", bbox: false, matteOnly: false, purpose: "발광 입자 구름" },
  { id: "glass-card-fan", fps: 30, frames: 90, durationSec: 3, aspect: V, tint: "baked", bbox: true, matteOnly: false, purpose: "유리 카드 3장 부채꼴 재료(틀만)" },
  { id: "iris-mask", fps: 30, frames: 30, durationSec: 1, aspect: V, tint: "none", bbox: false, matteOnly: true, purpose: "조리개 전환 마스크" },
  { id: "stair-wipe-mask", fps: 30, frames: 30, durationSec: 1, aspect: V, tint: "none", bbox: false, matteOnly: true, purpose: "계단 와이프 마스크" },
  // --- 모션 브리핑 3D 층(16:9 · 밝은 캔버스 · 무채색 · 09-30) ---
  { id: "orbs-back-169", fps: 60, frames: 180, durationSec: 3, aspect: L, tint: "neutral", bbox: false, matteOnly: false, purpose: "구슬 샌드위치 뒤층 16:9(글자 뒤) — 마지막 0.6초 바깥으로 빠짐" },
  { id: "orbs-front-169", fps: 60, frames: 180, durationSec: 3, aspect: L, tint: "neutral", bbox: false, matteOnly: false, purpose: "구슬 샌드위치 앞층 16:9(글자 앞)" },
  { id: "check-pop", fps: 60, frames: 36, durationSec: 0.6, aspect: L, tint: "neutral", bbox: true, matteOnly: false, purpose: "체크리스트 3D 체크 «톡»(튕겨 커짐)" },
  { id: "step-arrow", fps: 60, frames: 36, durationSec: 0.6, aspect: L, tint: "neutral", bbox: true, matteOnly: false, purpose: "단계 사이 3D 화살표 등장(왼쪽에서 밀려와 튕김)" },
  { id: "shape-sting", fps: 30, frames: 60, durationSec: 2, aspect: L, tint: "neutral", bbox: true, matteOnly: false, purpose: "오프닝·클로징 도형 스팅(원·다이아·삼각 조립 → 회전 → 퇴장 · 로고 아님)" },
  { id: "iris-mask-169", fps: 30, frames: 30, durationSec: 1, aspect: L, tint: "none", bbox: false, matteOnly: true, purpose: "조리개 전환 마스크 16:9" },
  { id: "stair-wipe-mask-169", fps: 30, frames: 30, durationSec: 1, aspect: L, tint: "none", bbox: false, matteOnly: true, purpose: "계단 와이프 마스크 16:9" },
];

/** 세로 쇼릴(9:16)이 고를 수 있는 id — 조립 EF 카탈로그 미러와 같아야 한다(`tests/unit/promo-reel-catalog-mirror.test.ts`). */
export const MOTION_3D_ASSET_IDS: ReadonlySet<string> = new Set(MOTION_3D_ASSETS.filter((a) => a.aspect === "9:16").map((a) => a.id));
/** 모션 브리핑(16:9) 3D 층이 고를 수 있는 id. */
export const MOTION_3D_ASSET_IDS_169: ReadonlySet<string> = new Set(MOTION_3D_ASSETS.filter((a) => a.aspect === "16:9").map((a) => a.id));

export function motion3dAsset(id: string): Motion3dAsset | undefined {
  return MOTION_3D_ASSETS.find((a) => a.id === id);
}

export const motion3dUrl = (id: string, file: "color.mp4" | "matte.mp4" | "alpha.webm" | "bbox.json"): string => `${MOTION_3D_BASE}/${id}/${file}`;

/** bbox.json 모양(1단계 `bake.py` 출력). */
export interface Motion3dBbox {
  asset: string;
  fps: number;
  width: number;
  height: number;
  parts: string[];
  /** 프레임별 합집합 [x0, y0, x1, y1] px(`width`×`height` 기준 — 세로 1080×1920 · 16:9 1920×1080). */
  frames: Array<[number, number, number, number]>;
}
